import { defineComponent as _defineComponent } from 'vue';
import { BButton } from "bootstrap-vue";
import { useRouter } from "vue-router/composables";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { library } from "@fortawesome/fontawesome-svg-core";
export default /*#__PURE__*/ _defineComponent({
    __name: 'PageIndexActions',
    setup(__props) {
        const router = useRouter();
        library.add(faPlus);
        function create() {
            router.push("/pages/create");
        }
        return { __sfc: true, router, create, BButton, FontAwesomeIcon };
    }
});
